/**
 * @generated SignedSource<<863351f9f4c721c476dafc49c8414f91>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AppointmentStatus = "CANCELLED" | "CLOSED" | "IN_PROGRESS" | "OPEN";
export type AppointmentType = "FLAT_LENGTH_FULL_HOUR" | "FOLLOW_UP" | "LONGER" | "NORMAL";
export type AsyncRequestStatus = "APPROVED" | "REJECTED";
export type CommunicationChannel = "ASYNC_REQUEST" | "CHAT" | "PHONE" | "VIDEO";
export type Country = "CH" | "DE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type MedgateConnectChannel = "PARTNER" | "PATIENT";
export type PointOfCareType = "EMERGENCY_CALL" | "EXTERNAL_ASSISTANCE" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE" | "HOSPITAL_EMERGENCY_ROOM" | "INCOMPLETE_TELECONSULTATION" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "SPECIALIST" | "TELECARE";
export type PreventionProgramTreatmentPlanTemplateCase = "NO_REGION_NO_ZIP" | "REGION" | "ZIP";
export type RequestType = "NONE" | "ONBOARDING_CALL" | "PLANNED_SELF_REFERRAL" | "PRESCRIPTION" | "PRESCRIPTION_ASTHMA" | "PRESCRIPTION_ATHLETES_FOOT" | "PRESCRIPTION_BLOOD_PRESSURE" | "PRESCRIPTION_CONTRACEPTIVE_PILL" | "PRESCRIPTION_ERECTILE_DYSFUNCTION" | "PRESCRIPTION_HAY_FEVER" | "PRESCRIPTION_HEARTBURN" | "PRESCRIPTION_HYPOTHYROIDISM" | "PRESCRIPTION_MIGRAINE" | "PRESCRIPTION_URINARY_TRACT_INFECTION" | "PRESCRIPTION_VAGINAL_MYCOSIS" | "REFERRAL" | "SICK_LEAVE_CERTIFICATE" | "SICK_LEAVE_FOR_LEGAL_GUARDIAN" | "SKIN_CHECK";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
import { FragmentRefs } from "relay-runtime";
export type PatientContextAppointmentFragment$data = {
  readonly appointmentType: AppointmentType;
  readonly asyncRequestStatus: AsyncRequestStatus | null;
  readonly billingAttribute: {
    readonly " $fragmentSpreads": FragmentRefs<"BillingAttributeFragment">;
  } | null;
  readonly channel: CommunicationChannel;
  readonly chatDetails: {
    readonly chatThreadId: string;
  } | null;
  readonly completedAt: string | null;
  readonly fileUploadRequest: {
    readonly " $fragmentSpreads": FragmentRefs<"FileUploadRequestFragment">;
  } | null;
  readonly id: string;
  readonly isCompleted: boolean;
  readonly language: Language;
  readonly medgateConnectChannel: MedgateConnectChannel | null;
  readonly partnerUserEmail: string | null;
  readonly patientAddress: {
    readonly city: string;
    readonly countryCode: string;
    readonly houseNumberStreet: string;
    readonly postalCode: string;
    readonly " $fragmentSpreads": FragmentRefs<"patientAddressTooltip_Address">;
  } | null;
  readonly patientPhoneNumber: string | null;
  readonly relatedPreventionPrograms: ReadonlyArray<{
    readonly analysis: {
      readonly matchedCase: PreventionProgramTreatmentPlanTemplateCase;
      readonly pointOfCare: PointOfCareType;
      readonly treatmentPlanTemplateId: string | null;
    };
    readonly country: Country;
    readonly id: string;
    readonly key: string;
    readonly name: {
      readonly de: string;
      readonly en: string;
    };
    readonly patientId: string;
    readonly preventionProgramId: string;
  }>;
  readonly requestType: RequestType;
  readonly service: Service;
  readonly startingSoonNotificationSent: boolean;
  readonly status: AppointmentStatus;
  readonly " $fragmentSpreads": FragmentRefs<"RequestedMedicationsFragment">;
  readonly " $fragmentType": "PatientContextAppointmentFragment";
};
export type PatientContextAppointmentFragment$key = {
  readonly " $data"?: PatientContextAppointmentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PatientContextAppointmentFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PatientContextAppointmentFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "service",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appointmentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientPhoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startingSoonNotificationSent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AppointmentChatDetails",
      "kind": "LinkedField",
      "name": "chatDetails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "chatThreadId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "channel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "medgateConnectChannel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partnerUserEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "asyncRequestStatus",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestedMedicationsFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BillingAttribute",
      "kind": "LinkedField",
      "name": "billingAttribute",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BillingAttributeFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FileUploadRequest",
      "kind": "LinkedField",
      "name": "fileUploadRequest",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FileUploadRequestFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "patientAddress",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "patientAddressTooltip_Address"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "houseNumberStreet",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postalCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "relatedPreventionPrograms",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "patientId",
          "storageKey": null
        },
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "preventionProgramId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LocalizedName",
          "kind": "LinkedField",
          "name": "name",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "en",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "de",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "country",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PreventionProgramAnalysis",
          "kind": "LinkedField",
          "name": "analysis",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "matchedCase",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pointOfCare",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "treatmentPlanTemplateId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};
})();

(node as any).hash = "e78d591e6bce23476c2792d82239496d";

export default node;
